// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 



// export default function APEDA() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Financial Assistance scheme from APEDA</h1>

//                                   <h2>1. ABOUT APEDA</h2>
//                                   <p>The Agricultural and Processed food Products Export Development Authority (APEDA) was established by the Government of India under the Agricultural and Processed food Products Export Development Authority Act, 1985. The primary objective of APEDA is to undertake the development and promotion of export of following products.</p>

//                                   <ul>
//                                       <li>Fruits, vegetables and their products,</li>
//                                       <li>Meat and meat products,</li>
//                                       <li>Poultry and poultry products,</li>
//                                       <li>Dairy products,</li>
//                                       <li>Confectionary, biscuits and bakery products,</li>
//                                       <li>Honey, jaggery and sugar products,</li>
//                                       <li>Cocoa and its products, chocolates of all kinds,</li>
//                                   </ul>
                                 
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <ul>
//                                       <li>Alcoholic and non-alcoholic beverages,</li>
//                                       <li>Cereals and Cereal products,</li>
//                                       <li>Groundnuts, peanuts and walnuts,</li>
//                                       <li>Pickles, chutneys and papads,</li>
//                                       <li>Guar Gum</li>
//                                       <li>Floriculture and floriculture products,</li>
//                                       <li>Herbal and medicinal plants.</li>
//                                       <li>Cashew kernels, cashew nut shell liquid, kardanol</li>
//                                   </ul>

//                                   <p>Following specific objectives have been laid down in Section 10(2) of the APEDA Act:</p>
//                                   <ul>
//                                       <li>the development of industries relating to the Scheduled products for export by way of providing financial assistance or otherwise for undertaking surveys and feasibility studies, participation in the equity capital through joint ventures and other reliefs and subsidy schemes;</li>
//                                       <li>the registration of persons as exporters of the Scheduled products on payment of such fees as may be prescribed;</li>
//                                       <li>the fixing of standards and specifications for the Scheduled products for the purposes of export;</li>
//                                       <li>the carrying out of inspection of meat and meat products in any slaughterhouse, processing, plant, storage premises, conveyances or other places where such products are kept or handled for the purpose of ensuring the quality of such products;</li>
//                                       <li>the improving of packaging of the Scheduled products;</li>
//                                       <li>the improving of the marketing of the Scheduled products outside India;</li>
//                                       <li>the promotion of export oriented production and development of the Scheduled products;</li>
//                                       <li>the promotion of export oriented production and development of the Scheduled products;</li>
//                                       <li>the collection of statistics from the owners of factories or establishments engaged in the production, processing, packaging, marketing or export of the Scheduled products or from such other persons as may be prescribed on any matter relating to the Scheduled products; and the publication of the statistics so collected, or of any portions thereof or extracts there from;</li>
//                                       <li>the training in various aspects of the industries connected with the Scheduled products;</li>
//                                       <li>such other matters as may be prescribed.</li>
//                                   </ul>

//                                   <p>In addition to the above, APEDA has also been entrusted with the task of registration and protection of the Intellectual Property rights in respect of ‘Special Products’ in India or Outside India. As present, the only ‘Special Product’, as listed in the Second Schedule to the APEDA Act, is Basmati Rice. After protracted efforts, APEDA was able to obtain GI registration for Basmati Rice in February 2016.</p>
//                                   <p>APEDA is also the Secretariat for National Programme for Organic Production, specifying the accreditation and certification programs for organic production. Organic certification programme covers all agricultural commodities including non- APEDA scheduled products. More than 10 lakh farmers are registered under the programme and the certification is a mandatory requirement for organic products exports.</p>
                                  
//                                   <h2>2. SCHEME COMPONENTS</h2>
//                                   <p>The Financial Assistance Scheme (FAS) is an export promotion scheme run by APEDA. The scheme aims to facilitate the export of agri-products by providing assistance to exporters. It achieves its objective through the following:</p>

//                                   <ul>
//                                       <li>Understanding the several challenges faced by agri-exporters</li>
//                                       <li>Acknowledging the need for assistance to successfully navigate through these challenges and achieve objectives of APEDA.</li>
//                                       <li>Financial assistance is provided in three broad areas, namely: Development of Export Infrastructure, Quality Development and Market Development.</li>
//                                   </ul>

//                                   <h2>Development of Export Infrastructure</h2>
//                                   <p>APEDA recognizes the importance of infrastructure for growth of agro-industries and export of agricultural products in the value chain. The scheme component covers both fresh produce and processed food products. The objective of the scheme is to reduce losses caused due to spoilage and to ensure quality production of agro products. To achieve this, it seeks to set up post-harvest handling facilities. Under this component, assistance is provided for the following:</p>

//                                   <ul>
//                                     <li>Infrastructure such as pack house facilities with packing/grading lines</li>
//                                     <li>Pre- cooling units with cold storages and refrigerated transportation etc</li>
//                                     <li>Cable system for handling of crops like banana</li>
//                                     <li>Common infrastructure facilities</li>
//                                     <li>Pre-shipment treatment facilities such as irradiation, Vapour Heat Treatment (VHT), Hot Water Dip Treatment (HWDT) for compliance to Phyto-Sanitary requirements of importing countries</li>
//                                     <li>Infrastructure for processing facilities (process food sector) for addressing missing gaps which may include equipment like X-ray, Screening, Sortex, filth / metal detector, sensors, vibrators or any new equipment or technology for food safety and quality requirements.</li>
//                                   </ul>

//                                   <h2>Quality Development</h2>
//                                   <p>To participate/engage in international trade, it is necessary to comply with Food Safety requirements of different countries. Several importing countries demand adherence to stringent Maximum Residue Levels (MRLs). Some of the developed importing countries have set up MRLs at very low level. For this, high precision equipments are required to be installed by the food testing labs. Under this component, assistance is provided to comply with the prescribed standards of importing countries. Assistance under this component covers the following:</p>

//                                   <ul>
//                                       <li>Installation of quality management systems,</li>
//                                       <li>Laboratory testing equipment,</li>
//                                       <li>Hand held devicesfor capturing farmlevel peripheral coordinatesfortraceability systems and testing of samples etc.</li>
//                                       <li>Testing of water, soil, residues or pesticides, veterinary drugs, hormones, toxins, heavy metal, contaminants etc.</li>
//                                   </ul>

//                                   <h2>Market Development</h2>
//                                   <p>This component helps exporters to achieve market access in new markets and help sustain their presence in the existing markets. It covers structured marketing strategies for export of food products, market intelligence for taking informed decisions, international exposure, skill development, capacity building and high quality packaging. The assistance under this component covers the following:</p>

//                                   <ul>
//                                       <li>Participation in International trade fairs</li>
//                                       <li>Exchange of trade delegations</li>
//                                       <li>Organizing buyer seller meets</li>
//                                       <li>Developing packaging standards for new products and upgrading the existing standards</li>
//                                   </ul>

//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// };


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaIndustry,
  FaChartLine,
  FaBoxes,
  FaHandsHelping
} from "react-icons/fa";

export default function APEDA() {
  return (
    <div className="bg-light py-5">
      <Container>

        {/* TITLE */}
        <Row>
          <Col>
            <h1>
              APEDA Financial Assistance Scheme
            </h1>

            <p>
              The APEDA Financial Assistance Scheme supports exporters in
              developing infrastructure, improving product quality, and expanding
              global market reach.
            </p>
          </Col>
        </Row>

        {/* ABOUT */}
        <h2 className="section-title">
          <FaGlobe /> About APEDA
        </h2>

        <p>
          APEDA (Agricultural and Processed Food Products Export Development Authority)
          promotes export of agricultural and processed food products and provides
          financial assistance to strengthen export capabilities.
        </p>

        {/* PRODUCTS */}
        <h2 className="section-title">
          <FaBoxes /> Products Covered
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Fruits & vegetables</li>
          <li><FaCheckCircle /> Meat & poultry products</li>
          <li><FaCheckCircle /> Dairy products</li>
          <li><FaCheckCircle /> Bakery & confectionery</li>
          <li><FaCheckCircle /> Cereals & processed foods</li>
          <li><FaCheckCircle /> Honey, spices & herbal products</li>
        </ul>

        {/* OBJECTIVE */}
        <h2 className="section-title">
          <FaChartLine /> Objective of the Scheme
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Promote agri exports</li>
          <li><FaCheckCircle /> Improve product quality</li>
          <li><FaCheckCircle /> Develop export infrastructure</li>
          <li><FaCheckCircle /> Support global market access</li>
        </ul>

        {/* COMPONENTS */}
        <h2 className="section-title">
          <FaIndustry /> Scheme Components
        </h2>

        {/* INFRA */}
        <h3>🏗 Export Infrastructure</h3>
        <ul className="custom-list">
          <li><FaCheckCircle /> Pack houses & grading lines</li>
          <li><FaCheckCircle /> Cold storage & pre-cooling units</li>
          <li><FaCheckCircle /> Refrigerated transport</li>
          <li><FaCheckCircle /> Processing equipment</li>
        </ul>

        {/* QUALITY */}
        <h3>🧪 Quality Development</h3>
        <ul className="custom-list">
          <li><FaCheckCircle /> Lab testing equipment</li>
          <li><FaCheckCircle /> Quality certification systems</li>
          <li><FaCheckCircle /> Residue & contamination testing</li>
          <li><FaCheckCircle /> Traceability systems</li>
        </ul>

        {/* MARKET */}
        <h3>🌍 Market Development</h3>
        <ul className="custom-list">
          <li><FaCheckCircle /> International trade fairs</li>
          <li><FaCheckCircle /> Buyer-seller meets</li>
          <li><FaCheckCircle /> Export branding & packaging</li>
          <li><FaCheckCircle /> Market research & intelligence</li>
        </ul>

        {/* BENEFITS */}
        <h2 className="section-title">
          <FaChartLine /> Key Benefits
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Financial support for exporters</li>
          <li><FaCheckCircle /> Improved product quality</li>
          <li><FaCheckCircle /> Reduced export losses</li>
          <li><FaCheckCircle /> Better global market access</li>
          <li><FaCheckCircle /> Increased export competitiveness</li>
        </ul>

        {/* HOW WE HELP */}
        <h2 className="section-title">
          <FaHandsHelping /> How We Help You
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Eligibility assessment</li>
          <li><FaCheckCircle /> Documentation & application filing</li>
          <li><FaCheckCircle /> APEDA coordination</li>
          <li><FaCheckCircle /> Project planning support</li>
          <li><FaCheckCircle /> End-to-end assistance</li>
        </ul>

        {/* WHY */}
        <h2 className="section-title">
          <FaGlobe /> Why Choose Apex
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Expert export consultants</li>
          <li><FaCheckCircle /> Fast processing</li>
          <li><FaCheckCircle /> High success rate</li>
          <li><FaCheckCircle /> Complete compliance support</li>
        </ul>

      </Container>
    </div>
  );
}